import { render, staticRenderFns } from "./changeBind.vue?vue&type=template&id=f639022c";
import script from "./changeBind.vue?vue&type=script&lang=js";
export * from "./changeBind.vue?vue&type=script&lang=js";
import style0 from "./changeBind.vue?vue&type=style&index=0&id=f639022c&prod&lang=less";

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, null, null);
export default component.exports;